import { IconButton, Tooltip } from '@joor/design-system'

import { OrderStatus } from '__generated__/atlas-types'

import { messages } from '../../constants/messages'
import { useAsyncAddOrdersToVA } from 'features/VisualAssortment/api/hooks/mutations/useAsyncAddOrdersToVA'
import { useHasVAAccess } from 'features/VisualAssortment/api/hooks/queries/useHasVAAccess'

export const VAButtonTestId = 'visual-assortment-button'

const AcceptedStatuses = [
  OrderStatus.APPROVED,
  OrderStatus.SHIPPED,
  OrderStatus.NOTES,
  OrderStatus.PENDING,
]

export const VisualAssortmentButton = ({
  id,
  orderId,
  orderStatus,
  productsCount,
}: {
  id: string
  orderId?: string
  orderStatus?: OrderStatus
  productsCount: number
}) => {
  const { hasVAAccess } = useHasVAAccess()
  const { asyncAddOrdersToVA, asyncAddingOrdersLoading } =
    useAsyncAddOrdersToVA()

  // No pre-check: the backend resolves whether the order is already in the
  // assortment, and creates the assortment when the account has none yet.
  const handleClick = async () => {
    if (!orderId) {
      return
    }

    try {
      await asyncAddOrdersToVA({ orderIds: [orderId] })
    } catch (error) {
      console.error('[VisualAssortmentButton] Error', error)
    }
  }

  const disabled =
    !orderStatus ||
    !AcceptedStatuses.includes(orderStatus) ||
    asyncAddingOrdersLoading ||
    productsCount === 0 ||
    !hasVAAccess

  return (
    <Tooltip defaultPlacement="bottom" content={messages.VAButton.text}>
      <IconButton
        id={id}
        iconName="visual-assortment"
        onClick={handleClick}
        data-testid={VAButtonTestId}
        disabled={disabled}
      />
    </Tooltip>
  )
}
